module.exports = __webpack_public_path__ + "53269d1e737072a23b53f1022d95a97f.png";